// frontend/src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all your translation files
import translationEN from './supported_languages/en/translation.json';
import translationDE from './supported_languages/de/translation.json';
import translationFR from './supported_languages/fr/translation.json';
import translationIT from './supported_languages/it/translation.json';
import translationES from './supported_languages/es/translation.json';
import translationPT from './supported_languages/pt/translation.json';
import translationJA from './supported_languages/ja/translation.json';
import translationZH from './supported_languages/zh/translation.json';
import translationKO from './supported_languages/ko/translation.json';
import translationRU from './supported_languages/ru/translation.json';
import translationAR from './supported_languages/ar/translation.json';
import translationHI from './supported_languages/hi/translation.json';


const resources = {
  en: { translation: translationEN },
  de: { translation: translationDE },
  es: { translation: translationES },
  it: { translation: translationIT },
  fr: { translation: translationFR },
  pt: { translation: translationPT },
  ja: { translation: translationJA },
  zh: { translation: translationZH },
  ko: { translation: translationKO },
  ru: { translation: translationRU },
  ar: { translation: translationAR },
  hi: { translation: translationHI },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // lng: 'en', // <-- This FORCES the initial language to English
    fallbackLng: 'en', // Use English if a translation is missing or language not supported
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
    detection: {
      order: ['localStorage', 'navigator', 'cookie'], // Order to detect language
      caches: ['localStorage', 'cookie'], // Where to cache the language
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;